import { StyleSheet } from 'react-native';

import { getColorTokenValue } from '@utility-nyc/react-native-ui-config';

const MOBILE_HEADER_CONTENT_HEIGHT = 54;
const HEADER_LEFT_BUTTON_SIZE = 40;

const privateStackNavigatorStyles = StyleSheet.create({
  headerLeft: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
  mobileHeaderLeft: {
    marginLeft: 8,
  },
  mobileHeader: {
    alignItems: 'center',
    backgroundColor: getColorTokenValue('$mono100'),
    flexDirection: 'row',
    justifyContent: 'center',
  },
  mobileHeaderLeftAbsolute: {
    left: 20,
    marginLeft: 0,
    position: 'absolute',
  },
  mobileHeaderTitle: {
    color: getColorTokenValue('$mono900'),
    fontFamily: 'Inter',
    fontSize: 17,
    fontWeight: '700',
    lineHeight: 22,
  },
  pressStyle: {
    opacity: 0.7,
  },
});

const getMobileHeaderContainerStyle = (safeAreaTop: number) => [
  privateStackNavigatorStyles.mobileHeader,
  {
    height: safeAreaTop + MOBILE_HEADER_CONTENT_HEIGHT,
    paddingTop: safeAreaTop,
  },
];

const getMobileHeaderLeftAbsoluteStyle = (safeAreaTop: number) => [
  privateStackNavigatorStyles.mobileHeaderLeftAbsolute,
  {
    top:
      safeAreaTop +
      (MOBILE_HEADER_CONTENT_HEIGHT - HEADER_LEFT_BUTTON_SIZE) / 2,
  },
];

export {
  privateStackNavigatorStyles,
  getMobileHeaderContainerStyle,
  getMobileHeaderLeftAbsoluteStyle,
};
